<template>
  <ConditionalTextarea
    v-model="crime"
    :radio-label="$tt('ever_convicted')"
    :textarea-label="$tt('describe_incident')"
  />
</template>

<script setup lang="ts">
const crime = defineModel<string>({ required: true });
</script>